import { useEffect } from 'react';
import triggerGoogleTagManagerCustomEvent from '../../common/utils/triggerGoogleTagManagerCustomEvent';
import GtmEvents from '../constants/gtmEvents';
import findAssociatedLabel from '../utils/findAssociatedLabel';

function useGtmButtonTracking() {
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      // Check if target is an Element (covers both HTMLElement and SVGElement)
      // This is important because clicking on icons/SVGs inside buttons should still track the button
      if (!(e.target instanceof Element)) {
        return;
      }

      const button = e.target.closest(
        'button:not([role="switch"]), [role="button"], input[type="button"], input[type="submit"]',
      );

      if (button instanceof HTMLElement) {
        const label = findAssociatedLabel(button);

        triggerGoogleTagManagerCustomEvent(GtmEvents.BUTTON_CLICK, {
          label,
          variant: button.dataset.variant,
        });
      }
    };

    document.addEventListener('click', handleClick, { capture: true });
    return () => document.removeEventListener('click', handleClick, { capture: true });
  }, []);
}

export default useGtmButtonTracking;
